{
  "version": 1,
  "asset_id": "b0011364-ea16-4743-8048-951fe99703b8",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/b0011364-ea16-4743-8048-951fe99703b8/home-verhuislift-flat.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/b0011364-ea16-4743-8048-951fe99703b8/home-verhuislift-flat.jpg",
  "original_filename": "home-verhuislift-flat.jpg",
  "size": 359009,
  "content_type": "image/jpeg",
  "created_at": "2026-08-31T21:27:09Z"
}
